const module = {
  config: {
    name: 'voting-module-archieve',
    icon: 'ri-user-line',
    desc: '',
    group: 'Postingan Diarsipkan',
    layout: true
  },
  routes: [
    { name: 'voting-archieve', label: 'Voting', icon: 'ri-pushpin-2-line', path: '/voting-archieve', component: () => import('./config-votings-archieve.vue') }
    // { name: 'voting', label: 'Berita', icon: 'ri-skip-right-fill', path: '/voting', component: () => import('./config-votings.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/voting-archieve/_index.js